import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  returnUrl: sharedEnvironment.sys.enkatRegisterUrl,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.sys.ansokanUrl,
  bpUrl: sharedEnvironment.sys.bpUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  projektApiUrl: `${sharedEnvironment.sys.gatewayUrl}/projekt`,
  projektSignalRUrl: `${sharedEnvironment.sys.gatewayUrl}/projekt`,
  etjansterCommonApiUrl: `${sharedEnvironment.sys.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/projekt`,
  sprakHanteringApiUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.sys.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.sys.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.sys.projektUrl,
  featureUrl: `${sharedEnvironment.sys.gatewayUrl}/projekt/feature`,
  externalLinks: sharedEnvironment.sys.externalLinks,
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  chatbotApiUrl: `${sharedEnvironment.sys.gatewayUrl}/projekt/chatbot`,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.sys.gatewayUrl}/projekt`,
      sharedEnvironment.sys.azureAdB2C.clientId.projektClientId,
      sharedEnvironment.sys.azureAdB2C.clientId.projektApiClientId,
    ),
    authority: sharedEnvironment.sys.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.sys.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.sys.azureAdB2C.clientId.projektApiClientId}/all`,
    tenant: sharedEnvironment.sys.azureAdB2C.tenant,
    policies: sharedEnvironment.sys.azureAdB2C.policies,
    clientId: sharedEnvironment.sys.azureAdB2C.clientId,
    allowRedirectInIframe: true,
  },
  ga4MeasurementId: sharedEnvironment.sys.ga4MeasurementId,
};
